import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import "./utils/chart";
import "./utils/filters";
import "./utils/globalComponents";
import router from "./router";
import store from "./store";
import axios from "./utils/request";
import common from "./mixins/common";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.mixin(common);

Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBiK4-gaLpyLL2Zk42ubfL1VjMbXDPpi6w",
        libraries: "places,drawing",
    },
});
Vue.prototype.$http = axios;
Vue.prototype.rootUrl = process.env.VUE_APP_API_BASE_URL;
Vue.prototype.s3BucketURL = process.env.VUE_APP_S3_BUCKET_URL;

export const EventBus = new Vue();

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app')